export default __webpack_public_path__ + "static/avatar-diagram-dark-8a180a4a11ac53c43316ecdd530cfa6e.png";